import type { Card } from '../../types';

export const FORTRESS: Card = {
  id: 'fortress',
  name: 'Fortress',
  type: 'defense',
  rarity: 'legendary',
  size: { w: 3, h: 2 },
  cost: [
    { kind: 'min', value: 4 },
    { kind: 'min', value: 4 },
    { kind: 'min', value: 4 },
  ],
  effects: [{ kind: 'block', amount: 20 }],
};
